export default class ZoneStore {
    /**
     * @param selectableZones {[String]}
     */
    constructor(selectableZones) {
        this.selectableZones = selectableZones;

        this.list = this.getHash().substring(1).split("&")
            .map(x => this.selectableZones.find(o => o === x))
            .filter(x => x != null);
    }

    /**
     * @return {String}
     */
    getHash() {
        return location.hash;
    }

    /**
     * @param hash {String}
     */
    setHash(hash) {
        location.hash = hash;
    }

    /**
     * @param zones {[String]}
     */
    save(zones) {
        this.list = zones;
        this.setHash(this.list.join("&"));
    }

    /**
     * @returns {[String]}
     */
    load() {
        return this.list;
    }
}